import { Address } from "../../api";

export const buildAddress = (address: Address): string | null => {
  const parts: string[] = [];
  if (address) {
    if (address.line1) {
      parts.push(address.line1);
    }
    if (address.line2) {
      parts.push(address.line2);
    }
    if (address.line3) {
      parts.push(address.line3);
    }
    if (address.city) {
      parts.push(address.city);
    }
    if (address.county) {
      parts.push(address.county);
    }

    if (address.country) {
      parts.push(address.country);
    }
    if (address.postCode) {
      parts.push(address.postCode);
    }
  }
  if (parts.length) {
    return parts.join(", ");
  }
  return null;
};
